export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // {
    //   name: 'dashboard',
    //   displayName: 'menu.dashboard',
    //   meta: {
    //     icon: 'vuestic-iconset-dashboard',
    //   },
    // },
    {
      name: 'cars',
      displayName: 'Kho xe',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'all-allocations',
      displayName: 'Allocation',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'new-car',
      displayName: 'Kinh doanh xe mới',
      meta: {
        icon: 'folder_shared',
      },
      children: [
        {
          name: 'sales-plan',
          displayName: 'Kế hoạch bán hàng',
          meta: {
            icon: 'folder_shared',
          },
        },
        {
          name: 'sales-quarter',
          displayName: 'KPI Quý',
          meta: {
            icon: 'folder_shared',
          },
        },
        {
          name: 'complaint',
          displayName: 'Khiếu nại bán hàng',
          meta: {
            icon: 'folder_shared',
          },
        },
        {
          name: 'selling-major',
          displayName: 'P. Bán hàng',
          meta: {
            icon: 'folder_shared',
          },
          children: [
            {
              name: 'sales-target',
              displayName: 'Chỉ tiêu bán hàng',
            },
            {
              name: 'sales-kpi-month',
              displayName: 'Đánh giá KPI',
            },
            {
              name: 'customer',
              displayName: 'Khách hàng mua xe',
            },
            {
              name: 'sell-request',
              displayName: 'Chăm sóc khách hàng mua xe',
            },
            {
              name: 'sales-form',
              displayName: 'Biểu mẫu khách hàng',
              children: [
                {
                  name: 'sell-form-lump-sum',
                  displayName: 'Giấy bán xe trả thẳng',
                },
                {
                  name: 'sell-form-installment',
                  displayName: 'Giấy bán xe trả góp',
                },
                {
                  name: 'receipt-form',
                  displayName: 'Phiếu thu',
                },
                {
                  name: 'agreement-form',
                  displayName: 'Biên bản thoả thuận',
                },
                {
                  name: 'handover-form',
                  displayName: 'Biên bản bàn giao xe & giấy tờ xe',
                },
                {
                  name: 'checking-form',
                  displayName: 'Giấy kiểm tra xe trước khi giao',
                },
                {
                  name: 'settlement-form',
                  displayName: 'Bảng quyết toán',
                },
              ],
            },
            {
              name: 'repair-suggestion',
              displayName: 'Đề nghị sửa chữa',
            },
            {
              name: 'sell-progress',
              displayName: 'Tiến độ bán xe',
            },
            // {
            //   name: 'retrieval-request',
            //   displayName: 'Đề nghị xuất hoá đơn',
            // },
            // {
            //   name: 'bank-request',
            //   displayName: 'Đề nghị xuất hoá đơn',
            // },
            {
              name: 'invoice-request',
              displayName: 'Đề nghị xuất hoá đơn',
            },
            {
              name: 'insurance-request',
              displayName: 'Đề nghị xuất bảo hiểm',
            },
            {
              name: 'sell-contract',
              displayName: 'Tóm tắt hợp đồng',
            },
            {
              name: 'handover-request',
              displayName: 'Lệnh giao xe',
            },
            {
              name: 'liquidation',
              displayName: 'Thanh lý hợp đồng',
            },
            {
              name: 'accessory-form',
              displayName: 'Yêu cầu phụ kiện',
            },
          ],
        },
      ],
    },
    {
      name: 'category',
      displayName: 'Cài đặt',
      meta: {
        icon: 'folder_shared',
      },
      children: [
        {
          name: 'category',
          displayName: 'Quản lý hãng xe',
        },
        {
          name: 'staff',
          displayName: 'Quản lý nhân viên',
        },
        {
          name: 'new-car-staff',
          displayName: 'Quản lý TVBH xe mới',
        },
      ],
    },
  ] as INavigationRoute[],
}
